window.VH = window.VH === undefined ? {} : window.VH;

VH.UserForm = {
    roleSelect : null,
    personContainer : null,

    checkPersonContainer : function checkPersonContainer()
    {
        let _t = VH.UserForm;
        if (_t.roleSelect.val() === 'client') {
            _t.personContainer.hide();
        } else {
            _t.personContainer.show();
        }
    },

    init : function init()
    {
        let _t = VH.UserForm;
        _t.roleSelect = $('#user-role');
        _t.personContainer = $('#person_code_container');

        _t.roleSelect.on('change', _t.checkPersonContainer);

        _t.checkPersonContainer();
    }

};
